<template>
  <div class="home-container">
    <div class="home-content" v-if="recordFlag">
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="活动名称"
                prop="title"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.title"
                  placeholder="请输入活动名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="活动状态"
                prop="title"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.status">
                  <el-option label="未开始" :value="1"></el-option>
                  <el-option label="进行中" :value="2"></el-option>
                  <el-option label="已结束" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        
        <el-table-column prop="id" label="活动id" align="center">
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center">
        </el-table-column>
        <el-table-column prop="img" label="活动图片" align="center" width="200px">
          <template slot-scope="scope">
            <img :src="scope.row.img" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="活动名称" align="center">
        </el-table-column>
        <el-table-column prop="activityTime" label="活动时间" align="center">
          <template slot-scope="scope">{{scope.row.startTime}} - {{ scope.row.endTime }}</template>
        </el-table-column>
        <el-table-column prop="signUpStartTime" label="报名时间" align="center">
          <template slot-scope="scope">{{scope.row.signUpStartTime}} - {{ scope.row.signUpEndTime }}</template>
        </el-table-column>
        <el-table-column
          prop="restrictNumber"
          label="限制报名人数"
          align="center"
        >
        </el-table-column>
         <el-table-column prop="integrals" label="奖励积分" align="center">
        </el-table-column>
        <el-table-column
          prop="status"
          label="活动状态"
          align="center"
          :formatter="activityStatus"
        >
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="活动记录" align="center">
          <template slot-scope="scope">
            <a @click="bindRecord(scope.row.id)">活动记录</a>
          </template>
        </el-table-column>
        
        <!-- <el-table-column prop="isRecommend" label="是否推荐" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isRecommend"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>         -->
        <el-table-column prop="enableStatus" label="是否启用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enableStatus"
              @change="updataStatus(scope.row)"
              :active-value="1"
              :inactive-value="-1"
            ></el-switch>
          </template>
        </el-table-column>        
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <!-- <el-button
              type="text"
              size="small"
              @click="sendNotice(scope.row)"
              >发送通知</el-button
            >               -->
            <el-button
              type="text"
              size="small"
              @click="copy(scope.row)"
              >复制</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%" @close="close" :close-on-click-modal="false">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-form-item label="排序" prop="sort">
            <el-input-number 
              v-model="addData.sort" 
              :precision="0" 
              :step="1" 
              :min="1" 
              placeholder="请输入排序"
              controls-position="right"
              @change="$refs.form.validateField('sort')"
              @blur="$refs.form.validateField('sort')">
            </el-input-number>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item label="活动图片" prop="img">
                <upload
                  :url.sync="addData.img"
                  :src="addData.img"
                  type="img"
                  :width="1920"
                  :height="930"
                ></upload>
                <div style="color: red"></div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="活动名称" prop="title">
                <el-input
                  placeholder="请输入活动名称"
                  v-model="addData.title"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="限制报名人数"
                prop="restrictNumber"
                label-width="120px"
              >
                <el-input-number
                  v-model="addData.restrictNumber"
                  label="限制报名人数"
                  :min="1"
                ></el-input-number>
                <!-- <el-input placeholder="限制报名人数" v-model="addData.restrictNumber"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="活动规则" prop="rule">
                <el-input type="textarea" :rows="5" maxlength="500" show-word-limit v-model="addData.rule" placeholder="请输入活动规则"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="活动地点" prop="address">
                <el-input v-model="addData.address" placeholder="请输入活动地点" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="奖励积分" prop="integrals">
                <!-- <el-input type="number" v-model="addData.integrals" placeholder="请输入奖励积分" maxlength="8"></el-input> -->
                <el-input-number 
                  v-model="addData.integrals" 
                  :precision="0" 
                  :step="1" 
                  :min="0" 
                  :max="99999999"
                  placeholder="请输入奖励积分"
                  controls-position="right"
                  @change="$refs.form.validateField('integrals')"
                  @blur="$refs.form.validateField('integrals')">
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="活动时间" prop="activityTime">
                <el-date-picker
                  v-model="addData.activityTime"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="报名时间" prop="signUpTime">
                <el-date-picker
                  v-model="addData.signUpTime"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="活动内容" prop="content">
                <ueditor v-model="addData.content"></ueditor>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div v-else>
      <activityRecord :activityId="activityId" @back="back"></activityRecord>
    </div>
    <send :index="2" @sendSubmit="sendSubmit" @isShowSend="sendFlags = false" v-if="sendFlags"></send>    
  </div>
</template>
<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor";
import activityRecord from "./activityRecord.vue";
import reg from "../../utils/reg";
import send from "../../components/send"
export default {
  components: {
    upload,
    ueditor,
    activityRecord,
    send
  },
  data() {
    return {
      searchForm: {
        site: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        img: "",
        activityTime: "",
        content: "",
        endTime: "",
        isRecommend: "",
        restrictNumber: "",
        signUpEndTime: "",
        signUpNumber: "",
        signUpStartTime: "",
        signUpTime: "",
        startTime: "",
        title: "",
        type: 1,
        rule:"",
        address:"",
        integrals:""
      },
      addDataRules: {
        img: [{ required: true, message: "请上传活动图片", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        rule: [{ required: true, message: "请输入活动规则", trigger: "blur" }],
        address: [{ required: true, message: "请输入活动地点", trigger: "blur" }],
        integrals: [{ required: true, message: "请输入奖励积分", trigger: "blur" }],
        
        restrictNumber: [
          { required: true, message: "请输入限制报名人数", trigger: "blur" },
        ],
        activityTime: [
          { required: true, message: "请选择活动时间", trigger: "blur" },
        ],
        signUpTime: [
          { required: true, message: "请选择报名时间", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入活动内容", trigger: "blur" },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      activityId: "",
      recordFlag: true,
      orderId:'',
      sendFlags:false,  
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    sendSubmit(data){
      data.entityId = this.orderId
      this.$Apis.sendActivity(data).then(res=>{
        if(res.code == 200){
          this.$message.success('发送成功')
          this.sendFlags = false 
        }else{
          this.$message.warning(res.code)
        }
      })
    },
    sendNotice(row){
      this.orderId = row.id
      this.sendFlags = true
    },    
    back() {
      this.recordFlag = true;
    },
    activityStatus(row) {
      if (row.status == 1) {
        return "未开始";
      } else if (row.status == 2) {
        return "进行中";
      } else if (row.status == 3) {
        return "已结束";
      }
    },
    // 活动记录
    bindRecord(row) {
      this.activityId = row;
      this.recordFlag = false;
    },
    // 修改状态
    updataStatus(row) {
      let data = {
        id:row.id,
        enableStatus:row.enableStatus
      };
      this.$Apis.activityEnableStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    close(){
      this.$refs.form.resetFields();
      this.isAddModal = false;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
    },
    copy(row){
      this.addData = JSON.parse(JSON.stringify(row));
      let arr = [],
        arrTime = [];
      arr.push(row.signUpStartTime);
      arr.push(row.signUpEndTime);
      arrTime.push(row.startTime);
      arrTime.push(row.endTime);
      this.addData.activityTime = arrTime;
      this.addData.signUpTime = arr;
      this.addData.id = ''
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      let arr = [],
        arrTime = [];
      arr.push(row.signUpStartTime);
      arr.push(row.signUpEndTime);
      arrTime.push(row.startTime);
      arrTime.push(row.endTime);
      this.addData.activityTime = arrTime;
      this.addData.signUpTime = arr;
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.activityDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.addData.startTime = this.addData.activityTime[0];
          this.addData.endTime = this.addData.activityTime[1];
          this.addData.signUpStartTime = this.addData.signUpTime[0]
          this.addData.signUpEndTime = this.addData.signUpTime[1]
          var data = {
            id: this.addData.id || "",
            img: this.addData.img,
            title: this.addData.title,
            restrictNumber: this.addData.restrictNumber,
            startTime: this.addData.startTime,
            endTime: this.addData.endTime,
            signUpStartTime: this.addData.signUpStartTime,
            signUpEndTime: this.addData.signUpEndTime,
            content: this.addData.content,
            type: 1,
            rule: this.addData.rule,
            address: this.addData.address,
            integrals: this.addData.integrals,
            sort: this.addData.sort
          };
          this.$Apis.activityAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm
        // type: 1,
      };
      this.$Apis.activityList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.isRecommend = item.isRecommend == 1 ? true : false;
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>